export default {
  open({ commit }, id) {
    commit("show", id);
  },
  close({ commit }) {
    commit("close");
  }
};
